import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { NextPageContext } from 'next';

export type ApolloPageContext = NextPageContext & {
  apolloClient?: ApolloClient<NormalizedCacheObject>;
};

export type PageProps = {
  isNotFound?: boolean;
  redirectTo?: string;
};

export const getQueryParam = (
  value: string | string[] | undefined
): string | undefined => {
  return Array.isArray(value) ? value[0] : value;
};

export const getCleanQueryParam = (
  value: string | string[] | undefined
): string | undefined => {
  return getQueryParam(value)?.split('?')[0];
};

export const markPageAsNotFound = (ctx: NextPageContext): void => {
  if (!ctx.res) return;

  ctx.res.statusCode = 404;
  ctx.res.setHeader('X-Robots-Tag', 'noindex, nofollow');
};
